import {Button, Dropdown} from 'react-bootstrap'
import {useChatContext} from '../Context'
import Recipients from './Recipients'
import {useMessageMutation} from '../hooks/useMessageMutation'
import ChatContentView from './ChatContentView'
import React from 'react'
import CustomDateRangePicker from '../../../../components/CustomDateRangePicker'
import DeleteConfirmationModal from '../../../../components/DeleteWarning'
import DeleteButton from '../../../../components/DeleteButton'

function ViewChat() {
  const {selectedOldChat, switchToNoChat} = useChatContext()
  const {deleteMutation} = useMessageMutation()

  if (!selectedOldChat) return <div>Chat not found</div>

  const handleDelete = () => {
    deleteMutation.mutate(selectedOldChat.id, {
      onSuccess: async () => {
        switchToNoChat()
      },
    })
  }

  const CustomToggle = React.forwardRef(({children, onClick}: any, ref: any) => {
    return (
      <Button
        variant="outline-secondary"
        size="sm"
        ref={ref}
        onClick={(e) => {
          e.preventDefault()
          onClick(e)
        }}
        className="px-2 py-1 rounded-1"
      >
        {children}
      </Button>
    )
  })

  return (
    <>
      <div className="d-flex h-100">
        <ChatContentView selectedChat={selectedOldChat} />
        <div className="bg-white p-5 rounded-end h-100 overflow-auto" style={{width: '40%'}}>
          <div className="d-flex align-items-center justify-content-between px-5 pb-4 mb-7 mx-n5 border-bottom border-gray-300">
            <div className="fs-3 text-center text-gray-700 flex-grow-1">Information</div>
            <Dropdown>
              <Dropdown.Toggle as={CustomToggle}>
                <i className="fa fa-ellipsis-vertical fs-3 p-0 text-gray-500" />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {/* <Dropdown.Item> */}
                <DeleteConfirmationModal onDelete={handleDelete}>
                  <div
                    className="px-3 py-1 bg-hover-light-info mx-2 fs-6 text-gray-700"
                    style={{width: '130px'}}
                  >
                    Delete
                  </div>
                </DeleteConfirmationModal>
                {/* </Dropdown.Item> */}
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <div className="fs-5 text-gray-600 mb-2">Message Schedule</div>
          <CustomDateRangePicker
            value={[new Date(selectedOldChat.dateFrom), new Date(selectedOldChat.dateTo)]}
            disabled
            clearIcon={null}
            rangeDivider="to"
            className="rounded w-auto px-5 py-1 bg-light border border-secondary"
          />
          <Recipients
            recieverType={selectedOldChat.receiverType}
            standard={{
              class_Name: selectedOldChat.class_Name,
              divisionName: selectedOldChat.divisionName,
            }}
            students={selectedOldChat.students}
          />
        </div>
      </div>
    </>
  )
}

export default ViewChat
